import { $ } from "@/common/Axios";

export default {
  /**
   * 经职院作业
   */
  jingjiWork: {
    /*
     * 添加
     * id id (integer query )
     * type 经济作业类型 (string query required)
     * theme 主题 (string query required)
     * title 题目 (string query required)
     * rollGrade 学籍年级 (string query required)
     * startTime 开始时间 (string query required)
     * endTime 结束时间 (string query required)
     * majorIds 专业（多选） (array query )
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiWork", p, c),
  },
  jingjiWork_saveReference: {
    /*
     * 添加范文
     * reference  ( query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/saveReference", p, c),
  },
  jingjiWork_finishWork: {
    /*
     * 生成学生作业
     * id id (integer query )
     * reCreate 是否重新生成 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiWork/finishWork", p, c),
  },
  jingjiWork_checkReference: {
    /*
     * 查看模板效果
     * id id (integer query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiWork/checkReference", p, c),
  },
  jingjiWork_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/list", p, c),
  },
  jingjiWork_listSignature: {
    /*
     * 学生签名列表
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/listSignature", p, c),
  },
  jingjiWork_listReference: {
    /*
     * 范文列表
     * id id (integer query required)
     * type 类型：试卷或作业或实训报告 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/listReference", p, c),
  },
  jingjiWork_listRecord: {
    /*
     * 学习记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/listRecord", p, c),
  },
  jingjiWork_exportSignature: {
    /*
     * 导出学生签名
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiWork/exportSignature", p, c),
  },
  jingjiWork_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiWork/exportRecord", p, c),
  },
  jingjiWork_removeReference: {
    /*
     * 删除范文
     * id id (integer query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeReference", p, c),
  },
  jingjiWork_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiWork/removeRecord", p, c),
  },

  /**
   * 经济学生试卷
   */
  jingjiPaper: {
    /*
     * 添加
     * id id (integer query )
     * name 名称 (string query required)
     * rollGrade 学籍年级 (string query required)
     */
    post: (p, c) => $.post("/api/ems/siteplatform/jingjiPaper", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/siteplatform/jingjiPaper", p, c),
  },
  jingjiPaper_finishPaper: {
    /*
     * 生成学生试卷
     * id id, 试卷列表的ID (integer query )
     * recordIds 记录列表的ID多选 (array query )
     * reCreate 是否重新生成 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/siteplatform/jingjiPaper/finishPaper", p, c),
  },
  jingjiPaper_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/list", p, c),
  },
  jingjiPaper_listRecord: {
    /*
     * 记录列表
     */
    get: (p, c) => $.get("/api/ems/siteplatform/jingjiPaper/listRecord", p, c),
  },
  jingjiPaper_exportRecord: {
    /*
     * 导出
     */
    get: (p, c) =>
      $.get("/api/ems/siteplatform/jingjiPaper/exportRecord", p, c),
  },
  jingjiPaper_removeRecord: {
    /*
     * 批量删除学生
     * ids ids (array query required)
     */
    delete: (p, c) =>
      $.delete("/api/ems/siteplatform/jingjiPaper/removeRecord", p, c),
  },
};
